export const getReplacements = ({ productId }) => ({
  url: `/me/products/${productId}/replacements`,
})
